import React, { FunctionComponent, memo } from "react";
import {
  Badge,
  Flex,
  Image,
  SpaceProps,
  SquareProps,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";

import AlarmsIndicator from "../alarms-indicator";
import { useNavigate } from "react-router-dom";


interface IProps extends SpaceProps, SquareProps {
  title?: string;
  subTitle?: string;
  subTitleTooltip?: string;
  alarmsLink?: string;
  icon?: string;
}


const CardTitle: FunctionComponent<IProps> = memo(function CardTitle({
  title,
  subTitle,
  subTitleTooltip,
  alarmsLink,
  icon,
  children,
  ...rest
}) {
  const navigate = useNavigate();
  const titleBg = useColorModeValue("enposol.50", "enposol.900");
  const subTitleBg = useColorModeValue("gray.200", "gray.800");

  return (
    <Flex justify="space-between" align="flex-start" {...rest}>
      {title && (
        <Text
          fontSize={"sm"}
          fontWeight={500}
          bg={titleBg}
          p={2}
          px={3}
          color={"enposol.500"}
          roundedBottomRight="2xl"
        >
          {title}
          {alarmsLink && <AlarmsIndicator
            onClick={() => {
              navigate(alarmsLink)
            }}
            size="xs"
            ml={1}
            mt={-2}
          />}
        </Text>
      )}
      {subTitle && !icon && (
        <Badge
          bg={subTitleBg}
          title={subTitleTooltip}
        >
          {subTitle}
        </Badge>
      )}
      {icon && !subTitle && (
        <Image src={icon} mt={2} mr={2} h={6} />
      )}
      {children}
    </Flex>
  );
});

export default CardTitle;
